module.exports = __webpack_public_path__ + "static/img/video3.4b20cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/video3.jpg
// module id = OH5h
// module chunks = 0